module.exports = __webpack_public_path__ + "static/CloudBattery-1-light-3595c50dacc7db84a7a9fdab672e590c.svg";